import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import ChannelOptionButton from './elements/channel-option-button';
import { colors, WhatsAppIcon } from '@aftersale-next/ui';
export default function WhatsappOption(props) {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsx(ChannelOptionButton, {
    label: t('WHATSAPP'),
    Icon: /*#__PURE__*/_jsx(WhatsAppIcon, {
      background: colors.buttonForeground
    }),
    accent: colors.whatsapp,
    onClick: props.onClick
  });
}